import styled from 'styled-components';

import { colors } from '../../ui/variables';

const EXAM_IMAGE_SIZE = 512;

export const AnnotationCanvasStyle = styled.div`
  height: ${EXAM_IMAGE_SIZE}px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: ${EXAM_IMAGE_SIZE}px;

  .annotation-list-container,
  .annotation-button {
    height: ${EXAM_IMAGE_SIZE}px;
    left: 0;
    position: absolute;
    top: 0;
    width: ${EXAM_IMAGE_SIZE}px;
  }

  .annotation-list-container {
    .annotation-item {
      border-radius: 50%;
      height: 20px;
      position: absolute;
      transform: translate(-50%, -50%);
      width: 20px;

      svg {
        display: block;
        fill: ${colors.veryDarkGrayishBlue};
        height: 10px;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 10px;
      }
    }
  }

  .annotation-button {
    &.hide {
      display: none;
    }
  }
`;
